var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconTel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.741 14.25A14.033 14.033 0 0 1 .75 3.254L3.25.75l.704.703 3.12 3.116-.742.74-1.23 1.231a9.022 9.022 0 0 0 3.402 3.385c.006.003 1.978-1.948 1.978-1.948l3.07 3.067.698.697-2.509 2.509z"
  })));
}
export default SvgCommonIconTel;